import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import UserHome from '@/components/UserHome'
import AdminHome from '@/components/AdminHome'
import UserDocuments from '@/components/UserDocuments'
import UserProfile from '@/components/UserProfile'
import UserStatistics from '@/components/UserStatistics'
import UserAdmin from '@/components/UserAdmin'
import ClientEmailInput from '@/components/ClientSettings/EmailInput'
import ClientSettings from '@/components/ClientSettings/Settings'
import ClientUsers from '@/components/ClientSettings/Users'
import ClientEnvProperties from '@/components/ClientSettings/EnvProperties'
import ClientUser from '@/components/ClientSettings/User'

import Callback from '@/components/Callback'
import SilentRenew from '@/components/SilentRenew'
import User2FA from '../components/User2FA'
import APISettings from '../components/ClientSettings/APISettings'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'HomeLogin',
      component: UserHome,
      meta: {requiresAuth: true}
    }, {
      path: '/callback',
      name: 'Callback',
      component: Callback
    }, {
      path: '/silent-renew',
      name: 'SilentRenew',
      component: SilentRenew
    }, {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path: '/user',
      component: UserHome,
      meta: {requiresAuth: true},
      children: [
        {
          path: '',
          name: 'UserHome',
          component: UserDocuments
        },
        {
          path: 'documents',
          name: 'UserDocuments',
          component: UserDocuments
        },
        {
          path: 'profile',
          name: 'UserProfile',
          component: UserProfile
        },
        {
          path: 'mfa',
          name: 'User2FA',
          component: User2FA
        },
        {
          path: 'admin',
          name: 'UserAdmin',
          redirect: 'admin/settings',
          component: UserAdmin,
          children: [
            {
              path: 'settings',
              name: 'ClientSettings',
              component: ClientSettings,
              meta: {
                title: 'Client Account Global Settings'
              }
            },
            {
              path: 'users',
              name: 'ClientUsers',
              component: ClientUsers,
              meta: {
                title: 'User Accounts'
              }
            },
            {
              path: 'email-input',
              name: 'ClientEmailInput',
              component: ClientEmailInput,
              meta: {
                title: 'Email Input Settings'
              }
            },
            {
              path: 'env-settings',
              name: 'ClientEnvProperties',
              component: ClientEnvProperties,
              meta: {
                title: 'Environment Properties'
              }
            },
            {
              path: 'api-settings',
              name: 'ClientAPISettings',
              component: APISettings,
              meta: {
                title: 'API Settings'
              }
            }
          ]
        },
        {
          path: 'statistics',
          name: 'UserStatistics',
          component: UserStatistics
        },
        {
          path: 'userdetails',
          name: 'UserDetails',
          component: ClientUser
        }
      ]
    }, {
      path: '/admin',
      name: 'Admin',
      component: AdminHome,
      meta: {requiresAuth: true, role: 'admin'}
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js